import { defaultOccDisplayText, type OccDisplayText } from '@vista-digital/occ-ui'

export const changeOccContextDisplayText = (data: OccDisplayText): OccDisplayText => {
    return {
        ...defaultOccDisplayText,
        ...data,
        numberCounterFormat: '${numerator}/${denominator}',
        seat: {
            ...defaultOccDisplayText.seat,
            ...data.seat,
            labelFormat: '${rowLabel}${seatLabel}',
            groupFormat: '${firstSeatLabel}–${lastSeatLabel}',
        },
        order: {
            ...defaultOccDisplayText.order,
            ...data.order,
            ticketDetailsFormat: '${quantity}x ${description}',
        },
    }
}
